function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.951 20.93L12.338.182a.403.403 0 00-.676 0L.049 20.929a.382.382 0 00.004.382.39.39 0 00.334.189h23.226a.388.388 0 00.334-.19.382.382 0 00.004-.38zM13 7.5l-.5 8h-1l-.5-8h2zm-1.25 12a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z",
  fill: "#FFA53E"
});

var SvgWarning = function SvgWarning(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 22
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTIzLjk1MSAyMC45M0wxMi4zMzguMTgyYS40MDMuNDAzIDAgMDAtLjY3NiAwTC4wNDkgMjAuOTI5YS4zODIuMzgyIDAgMDAuMDA0LjM4MmMuMDcuMTE3LjE5Ny4xODkuMzM0LjE4OWgyMy4yMjZhLjM4OC4zODggMCAwMC4zMzQtLjE5LjM4Mi4zODIgMCAwMC4wMDQtLjM4ek0xMyA3LjVsLS41IDhoLTFsLS41LThoMnptLTEuMjUgMTJhMS4yNSAxLjI1IDAgMTEwLTIuNSAxLjI1IDEuMjUgMCAwMTAgMi41eiIgZmlsbD0iI0ZGQTUzRSIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=";
export { SvgWarning as ReactComponent };